import { GridColDef } from '@mui/x-data-grid';

import { NewCandidateWidget } from '../../../../../features/composableAnalytics/DerivedCharts/helper';
import { renderCellFor } from '../../helper';
import {
  IPostgreNewCandidateDTO,
  IPostgreNewCandidateResultSet,
} from '../types/postgreNewCandidateDTO';

export const defaultNewCandidateWidgetData: IPostgreNewCandidateDTO = {
  count: 0,
  countByDate: {},
  resultSet: [],
};

export const getNewCandidateTableData = (
  widgetName: NewCandidateWidget,
  widgetData: IPostgreNewCandidateDTO
): [IPostgreNewCandidateResultSet[], GridColDef[]] => {
  let columns: GridColDef[] = [];
  switch (widgetName) {
    case NewCandidateWidget.CANDIDATE_RECRUITER_TABLE:
      columns = [
        {
          field: 'recruiterName',
          headerName: 'Recruiter Name',
          minWidth: 160,
          flex: 2,
          renderCell: (params) => renderCellFor('RECRUITER', params),
        },
        {
          field: 'count',
          headerName: `Count (${widgetData.count ?? 0})`,
          minWidth: 150,
          flex: 1,
        },
      ];
      break;
    case NewCandidateWidget.CANDIDATE_SOURCE_TABLE:
      columns = [
        { field: 'source', headerName: 'Source', minWidth: 170, flex: 2 },
        {
          field: 'count',
          headerName: `Count(${widgetData.count ?? 0})`,
          minWidth: 150,
          flex: 1,
        },
      ];
      break;
    case NewCandidateWidget.CANDIDATE_DOWNLOAD_SOURCE_TABLE:
      columns = [
        { field: 'downloadSource', headerName: 'Download Source', minWidth: 170, flex: 2 },
        {
          field: 'count',
          headerName: `Count(${widgetData.count ?? 0})`,
          minWidth: 150,
          flex: 1,
        },
      ];
      break;
    default:
      throw new Error("Invalid 'New Candidate Table Widget' type");
  }

  widgetData.resultSet.forEach((record, index) => (record.id = index));

  return [widgetData.resultSet, columns];
};
